import { render, staticRenderFns } from "./childCompanyDetail.vue?vue&type=template&id=f82b4194&scoped=true&"
import script from "./childCompanyDetail.vue?vue&type=script&lang=js&"
export * from "./childCompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./childCompanyDetail.vue?vue&type=style&index=0&id=f82b4194&scoped=true&lang=css&"
import style1 from "./childCompanyDetail.vue?vue&type=style&index=1&id=f82b4194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82b4194",
  null
  
)

export default component.exports